let mockData=[
    {
		kind: "calendar#event",
		etag: "\"3181161784712000\"",
		id: "4eahs9ghkhrvkld72hogu9ph3e_20200519T140000Z",
		status: "confirmed",
		htmlLink: "https://www.google.com/calendar/event?eid=NGVhaHM5Z2hraHJ2a2xkNzJob2d1OXBoM2VfMjAyMDA1MTlUMTQwMDAwWiBmdWxsc3RhY2t3ZWJkZXZAY2FyZWVyZm91bmRyeS5jb20",
		created: "2020-05-19T19:17:46.000Z",
		updated: "2020-05-27T12:01:32.356Z",
		summary: "Learn JavaScript",
		description: "Have you wondered how you can ask Google to show you the list of the top ten must-see places in London? And how Google presents you the list? How can you submit the details of an application? Well, JavaScript is doing these. :) \n\nJavascript offers interactivity to a dull, static website. Come, learn JavaScript with us and make those beautiful websites.",
		location: "London, UK",
		creator: {
			email: "fullstackwebdev@careerfoundry.com",
			self: true
		},
		organizer: {
			email: "fullstackwebdev@careerfoundry.com",
			self: true
		},
		start: {
			dateTime: "2020-05-19T16:00:00+02:00",
			timeZone: "Europe/Berlin"
		},
		end: {
			dateTime: "2020-05-19T17:00:00+02:00",
			timeZone: "Europe/Berlin"
		},
		recurringEventId: "4eahs9ghkhrvkld72hogu9ph3e",
		originalStartTime: {
			dateTime: "2020-05-19T16:00:00+02:00",
			timeZone: "Europe/Berlin"
		},
		iCalUID: "4eahs9ghkhrvkld72hogu9ph3e@google.com",
		sequence: 0,
		reminders: {
			useDefault: true
		},
		eventType: "default"
	},
	{
		kind: "calendar#event",
		etag: "\"3181159875584000\"",
		id: "3qtd6uscq4tsi6gc7nmmtpqlct_20200520T120000Z",
		status: "confirmed",
		htmlLink: "https://www.google.com/calendar/event?eid=M3F0ZDZ1c2NxNHRzaTZnYzdubW10cHFsY3RfMjAyMDA1MjBUMTIwMDAwWiBmdWxsc3RhY2t3ZWJkZXZAY2FyZWVyZm91bmRyeS5jb20",
		created: "2020-05-19T19:14:30.000Z",
		updated: "2020-05-27T11:45:37.792Z",
		summary: "React is Fun",
		description: "Love HTML, CSS, and JS? Want to become a cool front-end developer? \n\nReact is one of the most popular front-end frameworks. There is a huge number of job openings for React developers in most cities. \n\nJoin us in our free React training sessions and give your career a new direction. ",
		location: "Berlin, Germany",
		creator: {
			email: "fullstackwebdev@careerfoundry.com",
			self: true
		},
		organizer: {
			email: "fullstackwebdev@careerfoundry.com",
			self: true
		},
		start: {
			dateTime: "2020-05-20T14:00:00+02:00",
			timeZone: "Europe/Berlin"
		},
		end: {
			dateTime: "2020-05-20T15:00:00+02:00",
			timeZone: "Europe/Berlin"
		},
		recurringEventId: "3qtd6uscq4tsi6gc7nmmtpqlct",
		originalStartTime: {
			dateTime: "2020-05-20T14:00:00+02:00",
			timeZone: "Europe/Berlin"
		},
		iCalUID: "3qtd6uscq4tsi6gc7nmmtpqlct@google.com",
		sequence: 0,
		reminders: {
			useDefault: true
		},
		eventType: "default"
	},
	{
		kind: "calendar#event",
		etag: "\"3181161784712000\"",
		id: "4eahs9ghkhrvkld72hogu9ph3e_20200521T140000Z",
		status: "confirmed",
		htmlLink: "https://www.google.com/calendar/event?eid=NGVhaHM5Z2hraHJ2a2xkNzJob2d1OXBoM2VfMjAyMDA1MjFUMTQwMDAwWiBmdWxsc3RhY2t3ZWJkZXZAY2FyZWVyZm91bmRyeS5jb20",
		created: "2020-05-19T19:17:46.000Z",
		updated: "2020-05-27T12:01:32.356Z",
		summary: "Learn JavaScript",
		description: "Have you wondered how you can ask Google to show you the list of the top ten must-see places in London? And how Google presents you the list? How can you submit the details of an application? Well, JavaScript is doing these. :) \n\nJavascript offers interactivity to a dull, static website. Come, learn JavaScript with us and make those beautiful websites.",
		location: "London, UK",
		creator: {
			email: "fullstackwebdev@careerfoundry.com",
			self: true
		},
		organizer: {
			email: "fullstackwebdev@careerfoundry.com",
			self: true
		},
		start: {
			dateTime: "2020-05-21T16:00:00+02:00",
			timeZone: "Europe/Berlin"
		},
		end: {
			dateTime: "2020-05-21T17:00:00+02:00",
			timeZone: "Europe/Berlin"
		},
		recurringEventId: "4eahs9ghkhrvkld72hogu9ph3e",
		originalStartTime: {
			dateTime: "2020-05-21T16:00:00+02:00",
			timeZone: "Europe/Berlin"
		},
		iCalUID: "4eahs9ghkhrvkld72hogu9ph3e@google.com",
		sequence: 0,
		reminders: {
			useDefault: true
		},
		eventType: "default"
	},
	{
		kind: "calendar#event",
		etag: "\"3181159875584000\"",
		id: "3qtd6uscq4tsi6gc7nmmtpqlct_20200522T120000Z",
		status: "confirmed",
		htmlLink: "https://www.google.com/calendar/event?eid=M3F0ZDZ1c2NxNHRzaTZnYzdubW10cHFsY3RfMjAyMDA1MjJUMTIwMDAwWiBmdWxsc3RhY2t3ZWJkZXZAY2FyZWVyZm91bmRyeS5jb20",
		created: "2020-05-19T19:14:30.000Z",
		updated: "2020-05-27T11:45:37.792Z",
		summary: "React is Fun",
		description: "Love HTML, CSS, and JS? Want to become a cool front-end developer? \n\nReact is one of the most popular front-end frameworks. There is a huge number of job openings for React developers in most cities. \n\nJoin us in our free React training sessions and give your career a new direction. ",
		location: "Berlin, Germany",
		creator: {
			email: "fullstackwebdev@careerfoundry.com",
			self: true
		},
		organizer: {
			email: "fullstackwebdev@careerfoundry.com",
			self: true
		},
		start: {
			dateTime: "2020-05-22T14:00:00+02:00",
			timeZone: "Europe/Berlin"
		},
		end: {
			dateTime: "2020-05-22T15:00:00+02:00",
			timeZone: "Europe/Berlin"
		},
		recurringEventId: "3qtd6uscq4tsi6gc7nmmtpqlct",
		originalStartTime: {
			dateTime: "2020-05-22T14:00:00+02:00",
			timeZone: "Europe/Berlin"
		},
		iCalUID: "3qtd6uscq4tsi6gc7nmmtpqlct@google.com",
		sequence: 0,
		reminders: {
			useDefault: true
		},
		eventType: "default"
	},
	{
		kind: "calendar#event",
		etag: "\"3181161784712000\"",
		id: "4eahs9ghkhrvkld72hogu9ph3e_20200523T140000Z",
		status: "confirmed",
		htmlLink: "https://www.google.com/calendar/event?eid=NGVhaHM5Z2hraHJ2a2xkNzJob2d1OXBoM2VfMjAyMDA1MjNUMTQwMDAwWiBmdWxsc3RhY2t3ZWJkZXZAY2FyZWVyZm91bmRyeS5jb20",
		created: "2020-05-19T19:17:46.000Z",
		updated: "2020-05-27T12:01:32.356Z",
		summary: "Learn JavaScript",
		description: "Have you wondered how you can ask Google to show you the list of the top ten must-see places in London? And how Google presents you the list? How can you submit the details of an application? Well, JavaScript is doing these. :) \n\nJavascript offers interactivity to a dull, static website. Come, learn JavaScript with us and make those beautiful websites.",
		location: "London, UK",
		creator: {
			email: "fullstackwebdev@careerfoundry.com",
			self: true
		},
		organizer: {
			email: "fullstackwebdev@careerfoundry.com",
			self: true
		},
		start: {
			dateTime: "2020-05-23T16:00:00+02:00",
			timeZone: "Europe/Berlin"
		},
		end: {
			dateTime: "2020-05-23T17:00:00+02:00",
			timeZone: "Europe/Berlin"
		},
		recurringEventId: "4eahs9ghkhrvkld72hogu9ph3e",
		originalStartTime: {
			dateTime: "2020-05-23T16:00:00+02:00",
			timeZone: "Europe/Berlin"
		},
		iCalUID: "4eahs9ghkhrvkld72hogu9ph3e@google.com",
		sequence: 0,
		reminders: {
			useDefault: true
		},
		eventType: "default"
	},
	{
		kind: "calendar#event",
		etag: "\"3181159875584000\"",
		id: "3qtd6uscq4tsi6gc7nmmtpqlct_20200525T120000Z",
		status: "confirmed",
		htmlLink: "https://www.google.com/calendar/event?eid=M3F0ZDZ1c2NxNHRzaTZnYzdubW10cHFsY3RfMjAyMDA1MjVUMTIwMDAwWiBmdWxsc3RhY2t3ZWJkZXZAY2FyZWVyZm91bmRyeS5jb20",
		created: "2020-05-19T19:14:30.000Z",
		updated: "2020-05-27T11:45:37.792Z",
		summary: "React is Fun",
		description: "Love HTML, CSS, and JS? Want to become a cool front-end developer? \n\nReact is one of the most popular front-end frameworks. There is a huge number of job openings for React developers in most cities. \n\nJoin us in our free React training sessions and give your career a new direction. ",
		location: "Berlin, Germany",
		creator: {
			email: "fullstackwebdev@careerfoundry.com",
			self: true
		},
		organizer: {
			email: "fullstackwebdev@careerfoundry.com",
			self: true
		},
		start: {
			dateTime: "2020-05-25T14:00:00+02:00",
			timeZone: "Europe/Berlin"
		},
		end: {
			dateTime: "2020-05-25T15:00:00+02:00",
			timeZone: "Europe/Berlin"
		},
		recurringEventId: "3qtd6uscq4tsi6gc7nmmtpqlct",
		originalStartTime: {
			dateTime: "2020-05-25T14:00:00+02:00",
			timeZone: "Europe/Berlin"
		},
		iCalUID: "3qtd6uscq4tsi6gc7nmmtpqlct@google.com",
		sequence: 0,
		reminders: {
			useDefault: true
		},
		eventType: "default"
	},
	{
		kind: "calendar#event",
		etag: "\"3181161784712000\"",
		id: "4eahs9ghkhrvkld72hogu9ph3e_20200526T140000Z",
		status: "confirmed",
		htmlLink: "https://www.google.com/calendar/event?eid=NGVhaHM5Z2hraHJ2a2xkNzJob2d1OXBoM2VfMjAyMDA1MjZUMTQwMDAwWiBmdWxsc3RhY2t3ZWJkZXZAY2FyZWVyZm91bmRyeS5jb20",
		created: "2020-05-19T19:17:46.000Z",
		updated: "2020-05-27T12:01:32.356Z",
		summary: "Learn JavaScript",
		description: "Have you wondered how you can ask Google to show you the list of the top ten must-see places in London? And how Google presents you the list? How can you submit the details of an application? Well, JavaScript is doing these. :) \n\nJavascript offers interactivity to a dull, static website. Come, learn JavaScript with us and make those beautiful websites.",
		location: "London, UK",
		creator: {
			email: "fullstackwebdev@careerfoundry.com",
			self: true
		},
		organizer: {
			email: "fullstackwebdev@careerfoundry.com",
			self: true
		},
		start: {
			dateTime: "2020-05-26T16:00:00+02:00",
			timeZone: "Europe/Berlin"
		},
		end: {
			dateTime: "2020-05-26T17:00:00+02:00",
			timeZone: "Europe/Berlin"
		},
		recurringEventId: "4eahs9ghkhrvkld72hogu9ph3e",
		originalStartTime: {
			dateTime: "2020-05-26T16:00:00+02:00",
			timeZone: "Europe/Berlin"
		},
		iCalUID: "4eahs9ghkhrvkld72hogu9ph3e@google.com",
		sequence: 0,
		reminders: {
			useDefault: true
		},
		eventType: "default"
	},
	{
		kind: "calendar#event",
		etag: "\"3181159875584000\"",
		id: "3qtd6uscq4tsi6gc7nmmtpqlct_20200527T120000Z",
		status: "confirmed",
		htmlLink: "https://www.google.com/calendar/event?eid=M3F0ZDZ1c2NxNHRzaTZnYzdubW10cHFsY3RfMjAyMDA1MjdUMTIwMDAwWiBmdWxsc3RhY2t3ZWJkZXZAY2FyZWVyZm91bmRyeS5jb20",
		created: "2020-05-19T19:14:30.000Z",
		updated: "2020-05-27T11:45:37.792Z",
		summary: "React is Fun",
		description: "Love HTML, CSS, and JS? Want to become a cool front-end developer? \n\nReact is one of the most popular front-end frameworks. There is a huge number of job openings for React developers in most cities. \n\nJoin us in our free React training sessions and give your career a new direction. ",
		location: "Berlin, Germany",
		creator: {
			email: "fullstackwebdev@careerfoundry.com",
			self: true
		},
		organizer: {
			email: "fullstackwebdev@careerfoundry.com",
			self: true
		},
		start: {
			dateTime: "2020-05-27T14:00:00+02:00",
			timeZone: "Europe/Berlin"
		},
		end: {
			dateTime: "2020-05-27T15:00:00+02:00",
			timeZone: "Europe/Berlin"
		},
		recurringEventId: "3qtd6uscq4tsi6gc7nmmtpqlct",
		originalStartTime: {
			dateTime: "2020-05-27T14:00:00+02:00",
			timeZone: "Europe/Berlin"
		},
		iCalUID: "3qtd6uscq4tsi6gc7nmmtpqlct@google.com",
		sequence: 0,
		reminders: {
			useDefault: true
		},
		eventType: "default"
	},
	{
		kind: "calendar#event",
		etag: "\"3181161784712000\"",
		id: "4eahs9ghkhrvkld72hogu9ph3e_20200528T140000Z",
		status: "confirmed",
		htmlLink: "https://www.google.com/calendar/event?eid=NGVhaHM5Z2hraHJ2a2xkNzJob2d1OXBoM2VfMjAyMDA1MjhUMTQwMDAwWiBmdWxsc3RhY2t3ZWJkZXZAY2FyZWVyZm91bmRyeS5jb20",
		created: "2020-05-19T19:17:46.000Z",
		updated: "2020-05-27T12:01:32.356Z",
		summary: "Learn JavaScript",
		description: "Have you wondered how you can ask Google to show you the list of the top ten must-see places in London? And how Google presents you the list? How can you submit the details of an application? Well, JavaScript is doing these. :) \n\nJavascript offers interactivity to a dull, static website. Come, learn JavaScript with us and make those beautiful websites.",
		location: "London, UK",
		creator: {
			email: "fullstackwebdev@careerfoundry.com",
			self: true
		},
		organizer: {
			email: "fullstackwebdev@careerfoundry.com",
			self: true
		},
		start: {
			dateTime: "2020-05-28T16:00:00+02:00",
			timeZone: "Europe/Berlin"
		},
		end: {
			dateTime: "2020-05-28T17:00:00+02:00",
			timeZone: "Europe/Berlin"
		},
		recurringEventId: "4eahs9ghkhrvkld72hogu9ph3e",
		originalStartTime: {
			dateTime: "2020-05-28T16:00:00+02:00",
			timeZone: "Europe/Berlin"
		},
		iCalUID: "4eahs9ghkhrvkld72hogu9ph3e@google.com",
		sequence: 0,
		reminders: {
			useDefault: true
		},
		eventType: "default"
	},
	{
		kind: "calendar#event",
		etag: "\"3181159875584000\"",
		id: "3qtd6uscq4tsi6gc7nmmtpqlct_20200529T120000Z",
		status: "confirmed",
		htmlLink: "https://www.google.com/calendar/event?eid=M3F0ZDZ1c2NxNHRzaTZnYzdubW10cHFsY3RfMjAyMDA1MjlUMTIwMDAwWiBmdWxsc3RhY2t3ZWJkZXZAY2FyZWVyZm91bmRyeS5jb20",
		created: "2020-05-19T19:14:30.000Z",
		updated: "2020-05-27T11:45:37.792Z",
		summary: "React is Fun",
		description: "Love HTML, CSS, and JS? Want to become a cool front-end developer? \n\nReact is one of the most popular front-end frameworks. There is a huge number of job openings for React developers in most cities. \n\nJoin us in our free React training sessions and give your career a new direction. ",
		location: "Berlin, Germany",
		creator: {
			email: "fullstackwebdev@careerfoundry.com",
			self: true
		},
		organizer: {
			email: "fullstackwebdev@careerfoundry.com",
			self: true
		},
		start: {
			dateTime: "2020-05-29T14:00:00+02:00",
			timeZone: "Europe/Berlin"
		},
		end: {
			dateTime: "2020-05-29T15:00:00+02:00",
			timeZone: "Europe/Berlin"
		},
		recurringEventId: "3qtd6uscq4tsi6gc7nmmtpqlct",
		originalStartTime: {
			dateTime: "2020-05-29T14:00:00+02:00",
			timeZone: "Europe/Berlin"
		},
		iCalUID: "3qtd6uscq4tsi6gc7nmmtpqlct@google.com",
		sequence: 0,
		reminders: {
			useDefault: true
		},
		eventType: "default"
	},
	{
		kind: "calendar#event",
		etag: "\"3181161784712000\"",
		id: "4eahs9ghkhrvkld72hogu9ph3e_20200530T140000Z",
		status: "confirmed",
		htmlLink: "https://www.google.com/calendar/event?eid=NGVhaHM5Z2hraHJ2a2xkNzJob2d1OXBoM2VfMjAyMDA1MzBUMTQwMDAwWiBmdWxsc3RhY2t3ZWJkZXZAY2FyZWVyZm91bmRyeS5jb20",
		created: "2020-05-19T19:17:46.000Z",
		updated: "2020-05-27T12:01:32.356Z",
		summary: "Learn JavaScript",
		description: "Have you wondered how you can ask Google to show you the list of the top ten must-see places in London? And how Google presents you the list? How can you submit the details of an application? Well, JavaScript is doing these. :) \n\nJavascript offers interactivity to a dull, static website. Come, learn JavaScript with us and make those beautiful websites.",
		location: "London, UK",
		creator: {
			email: "fullstackwebdev@careerfoundry.com",
			self: true
		},
		organizer: {
			email: "fullstackwebdev@careerfoundry.com",
			self: true
		},
		start: {
			dateTime: "2020-05-30T16:00:00+02:00",
			timeZone: "Europe/Berlin"
		},
		end: {
			dateTime: "2020-05-30T17:00:00+02:00",
			timeZone: "Europe/Berlin"
		},
		recurringEventId: "4eahs9ghkhrvkld72hogu9ph3e",
		originalStartTime: {
			dateTime: "2020-05-30T16:00:00+02:00",
			timeZone: "Europe/Berlin"
		},
		iCalUID: "4eahs9ghkhrvkld72hogu9ph3e@google.com",
		sequence: 0,
		reminders: {
			useDefault: true
		},
		eventType: "default"
	},
	{
		kind: "calendar#event",
		etag: "\"3181159875584000\"",
		id: "3qtd6uscq4tsi6gc7nmmtpqlct_20200601T120000Z",
		status: "confirmed",
		htmlLink: "https://www.google.com/calendar/event?eid=M3F0ZDZ1c2NxNHRzaTZnYzdubW10cHFsY3RfMjAyMDA2MDFUMTIwMDAwWiBmdWxsc3RhY2t3ZWJkZXZAY2FyZWVyZm91bmRyeS5jb20",
		created: "2020-05-19T19:14:30.000Z",
		updated: "2020-05-27T11:45:37.792Z",
		summary: "React is Fun",
		description: "Love HTML, CSS, and JS? Want to become a cool front-end developer? \n\nReact is one of the most popular front-end frameworks. There is a huge number of job openings for React developers in most cities. \n\nJoin us in our free React training sessions and give your career a new direction. ",
		location: "Berlin, Germany",
		creator: {
			email: "fullstackwebdev@careerfoundry.com",
			self: true
		},
		organizer: {
			email: "fullstackwebdev@careerfoundry.com",
			self: true
		},
		start: {
			dateTime: "2020-06-01T14:00:00+02:00",
			timeZone: "Europe/Berlin"
		},
		end: {
			dateTime: "2020-06-01T15:00:00+02:00",
			timeZone: "Europe/Berlin"
		},
		recurringEventId: "3qtd6uscq4tsi6gc7nmmtpqlct",
		originalStartTime: {
			dateTime: "2020-06-01T14:00:00+02:00",
			timeZone: "Europe/Berlin"
		},
		iCalUID: "3qtd6uscq4tsi6gc7nmmtpqlct@google.com",
		sequence: 0,
		reminders: {
			useDefault: true
		},
		eventType: "default"
	},
	{
		kind: "calendar#event",
		etag: "\"3181161784712000\"",
		id: "4eahs9ghkhrvkld72hogu9ph3e_20200602T140000Z",
		status: "confirmed",
		htmlLink: "https://www.google.com/calendar/event?eid=NGVhaHM5Z2hraHJ2a2xkNzJob2d1OXBoM2VfMjAyMDA2MDJUMTQwMDAwWiBmdWxsc3RhY2t3ZWJkZXZAY2FyZWVyZm91bmRyeS5jb20",
		created: "2020-05-19T19:17:46.000Z",
		updated: "2020-05-27T12:01:32.356Z",
		summary: "Learn JavaScript",
		description: "Have you wondered how you can ask Google to show you the list of the top ten must-see places in London? And how Google presents you the list? How can you submit the details of an application? Well, JavaScript is doing these. :) \n\nJavascript offers interactivity to a dull, static website. Come, learn JavaScript with us and make those beautiful websites.",
		location: "London, UK",
		creator: {
			email: "fullstackwebdev@careerfoundry.com",
			self: true
		},
		organizer: {
			email: "fullstackwebdev@careerfoundry.com",
			self: true
		},
		start: {
			dateTime: "2020-06-02T16:00:00+02:00",
			timeZone: "Europe/Berlin"
		},
		end: {
			dateTime: "2020-06-02T17:00:00+02:00",
			timeZone: "Europe/Berlin"
		},
		recurringEventId: "4eahs9ghkhrvkld72hogu9ph3e",
		originalStartTime: {
			dateTime: "2020-06-02T16:00:00+02:00",
			timeZone: "Europe/Berlin"
		},
		iCalUID: "4eahs9ghkhrvkld72hogu9ph3e@google.com",
		sequence: 0,
		reminders: {
			useDefault: true
		},
		eventType: "default"
	},
	{
		kind: "calendar#event",
		etag: "\"3181159875584000\"",
		id: "3qtd6uscq4tsi6gc7nmmtpqlct_20200603T120000Z",
		status: "confirmed",
		htmlLink: "https://www.google.com/calendar/event?eid=M3F0ZDZ1c2NxNHRzaTZnYzdubW10cHFsY3RfMjAyMDA2MDNUMTIwMDAwWiBmdWxsc3RhY2t3ZWJkZXZAY2FyZWVyZm91bmRyeS5jb20",
		created: "2020-05-19T19:14:30.000Z",
		updated: "2020-05-27T11:45:37.792Z",
		summary: "React is Fun",
		description: "Love HTML, CSS, and JS? Want to become a cool front-end developer? \n\nReact is one of the most popular front-end frameworks. There is a huge number of job openings for React developers in most cities. \n\nJoin us in our free React training sessions and give your career a new direction. ",
		location: "Berlin, Germany",
		creator: {
			email: "fullstackwebdev@careerfoundry.com",
			self: true
		},
		organizer: {
			email: "fullstackwebdev@careerfoundry.com",
			self: true
		},
		start: {
			dateTime: "2020-06-03T14:00:00+02:00",
			timeZone: "Europe/Berlin"
		},
		end: {
			dateTime: "2020-06-03T15:00:00+02:00",
			timeZone: "Europe/Berlin"
		},
		recurringEventId: "3qtd6uscq4tsi6gc7nmmtpqlct",
		originalStartTime: {
			dateTime: "2020-06-03T14:00:00+02:00",
			timeZone: "Europe/Berlin"
		},
		iCalUID: "3qtd6uscq4tsi6gc7nmmtpqlct@google.com",
		sequence: 0,
		reminders: {
			useDefault: true
		},
		eventType: "default"
	},
	{
		kind: "calendar#event",
		etag: "\"3181161784712000\"",
		id: "4eahs9ghkhrvkld72hogu9ph3e_20200604T140000Z",
		status: "confirmed",
		htmlLink: "https://www.google.com/calendar/event?eid=NGVhaHM5Z2hraHJ2a2xkNzJob2d1OXBoM2VfMjAyMDA2MDRUMTQwMDAwWiBmdWxsc3RhY2t3ZWJkZXZAY2FyZWVyZm91bmRyeS5jb20",
		created: "2020-05-19T19:17:46.000Z",
		updated: "2020-05-27T12:01:32.356Z",
		summary: "Learn JavaScript",
		description: "Have you wondered how you can ask Google to show you the list of the top ten must-see places in London? And how Google presents you the list? How can you submit the details of an application? Well, JavaScript is doing these. :) \n\nJavascript offers interactivity to a dull, static website. Come, learn JavaScript with us and make those beautiful websites.",
		location: "London, UK",
		creator: {
			email: "fullstackwebdev@careerfoundry.com",
			self: true
		},
		organizer: {
			email: "fullstackwebdev@careerfoundry.com",
			self: true
		},
		start: {
			dateTime: "2020-06-04T16:00:00+02:00",
			timeZone: "Europe/Berlin"
		},
		end: {
			dateTime: "2020-06-04T17:00:00+02:00",
			timeZone: "Europe/Berlin"
		},
		recurringEventId: "4eahs9ghkhrvkld72hogu9ph3e",
		originalStartTime: {
			dateTime: "2020-06-04T16:00:00+02:00",
			timeZone: "Europe/Berlin"
		},
		iCalUID: "4eahs9ghkhrvkld72hogu9ph3e@google.com",
		sequence: 0,
		reminders: {
			useDefault: true
		},
		eventType: "default"
	},
	{
		kind: "calendar#event",
		etag: "\"3181159875584000\"",
		id: "3qtd6uscq4tsi6gc7nmmtpqlct_20200605T120000Z",
		status: "confirmed",
		htmlLink: "https://www.google.com/calendar/event?eid=M3F0ZDZ1c2NxNHRzaTZnYzdubW10cHFsY3RfMjAyMDA2MDVUMTIwMDAwWiBmdWxsc3RhY2t3ZWJkZXZAY2FyZWVyZm91bmRyeS5jb20",
		created: "2020-05-19T19:14:30.000Z",
		updated: "2020-05-27T11:45:37.792Z",
		summary: "React is Fun",
		description: "Love HTML, CSS, and JS? Want to become a cool front-end developer? \n\nReact is one of the most popular front-end frameworks. There is a huge number of job openings for React developers in most cities. \n\nJoin us in our free React training sessions and give your career a new direction. ",
		location: "Berlin, Germany",
		creator: {
			email: "fullstackwebdev@careerfoundry.com",
			self: true
		},
		organizer: {
			email: "fullstackwebdev@careerfoundry.com",
			self: true
		},
		start: {
			dateTime: "2020-06-05T14:00:00+02:00",
			timeZone: "Europe/Berlin"
		},
		end: {
			dateTime: "2020-06-05T15:00:00+02:00",
			timeZone: "Europe/Berlin"
		},
		recurringEventId: "3qtd6uscq4tsi6gc7nmmtpqlct",
		originalStartTime: {
			dateTime: "2020-06-05T14:00:00+02:00",
			timeZone: "Europe/Berlin"
		},
		iCalUID: "3qtd6uscq4tsi6gc7nmmtpqlct@google.com",
		sequence: 0,
		reminders: {
			useDefault: true
		},
		eventType: "default"
	},
    {
		kind: "calendar#event",
		etag: "\"3187232532588000\"",
		id: "20c51je3q99mnolr1rp06dt9jd_20200801T120000Z",
		status: "confirmed",
		htmlLink: "https://www.google.com/calendar/event?eid=MjBjNTFqZTNxOTltbm9scjFycDA2ZHQ5amRfMjAyMDA4MDFUMTIwMDAwWiBmdWxsc3RhY2t3ZWJkZXZAY2FyZWVyZm91bmRyeS5jb20",
		created: "2020-07-01T14:17:12.000Z",
		updated: "2020-07-01T15:11:06.294Z",
		summary: "Use jQuery, bring in interactivity easily ",
		description: "Do you know jQuery is used by around 70 percent of the 10 million most popular websites as of May 2019? \n\nThough many consider it dead after Angular and Express gained popularity, jQuery is still an important part of many websites. \n\nIn our workshop, we teach basic to advanced jQuery where you will also be able to build a simple app using it. If you are familiar with JS, join us to learn probably its most popular library.",
		location: "Mumbai, Maharashtra, India",
		creator: {
			email: "fullstackwebdev@careerfoundry.com",
			self: true
		},
		organizer: {
			email: "fullstackwebdev@careerfoundry.com",
			self: true
		},
		start: {
			dateTime: "2020-08-01T14:00:00+02:00",
			timeZone: "Europe/Berlin"
		},
		end: {
			dateTime: "2020-08-01T15:00:00+02:00",
			timeZone: "Europe/Berlin"
		},
		recurringEventId: "20c51je3q99mnolr1rp06dt9jd",
		originalStartTime: {
			dateTime: "2020-08-01T14:00:00+02:00",
			timeZone: "Europe/Berlin"
		},
		iCalUID: "20c51je3q99mnolr1rp06dt9jd@google.com",
		sequence: 1,
		hangoutLink: "https://meet.google.com/nns-htdr-ijk",
		conferenceData: {
			entryPoints: [
				{
					entryPointType: "video",
					uri: "https://meet.google.com/nns-htdr-ijk",
					label: "meet.google.com/nns-htdr-ijk"
				},
				{
					entryPointType: "more",
					uri: "https://tel.meet/nns-htdr-ijk?pin=9302146320475",
					pin: "9302146320475"
				},
				{
					regionCode: "DE",
					entryPointType: "phone",
					uri: "tel:+49-40-8081618430",
					label: "+49 40 8081618430",
					pin: "810644618"
				}
			],
			conferenceSolution: {
				key: {
					type: "hangoutsMeet"
				},
				name: "Google Meet",
				iconUri: "https://fonts.gstatic.com/s/i/productlogos/meet_2020q4/v6/web-512dp/logo_meet_2020q4_color_2x_web_512dp.png"
			},
			conferenceId: "nns-htdr-ijk"
		},
		reminders: {
			useDefault: true
		},
		eventType: "default"
	},
	{
		kind: "calendar#event",
		etag: "\"3181161784712000\"",
		id: "4eahs9ghkhrvkld72hogu9ph3e_20200801T140000Z",
		status: "confirmed",
		htmlLink: "https://www.google.com/calendar/event?eid=NGVhaHM5Z2hraHJ2a2xkNzJob2d1OXBoM2VfMjAyMDA4MDFUMTQwMDAwWiBmdWxsc3RhY2t3ZWJkZXZAY2FyZWVyZm91bmRyeS5jb20",
		created: "2020-05-19T19:17:46.000Z",
		updated: "2020-05-27T12:01:32.356Z",
		summary: "Learn JavaScript",
		description: "Have you wondered how you can ask Google to show you the list of the top ten must-see places in London? And how Google presents you the list? How can you submit the details of an application? Well, JavaScript is doing these. :) \n\nJavascript offers interactivity to a dull, static website. Come, learn JavaScript with us and make those beautiful websites.",
		location: "London, UK",
		creator: {
			email: "fullstackwebdev@careerfoundry.com",
			self: true
		},
		organizer: {
			email: "fullstackwebdev@careerfoundry.com",
			self: true
		},
		start: {
			dateTime: "2020-08-01T16:00:00+02:00",
			timeZone: "Europe/Berlin"
		},
		end: {
			dateTime: "2020-08-01T17:00:00+02:00",
			timeZone: "Europe/Berlin"
		},
		recurringEventId: "4eahs9ghkhrvkld72hogu9ph3e",
		originalStartTime: {
			dateTime: "2020-08-01T16:00:00+02:00",
			timeZone: "Europe/Berlin"
		},
		iCalUID: "4eahs9ghkhrvkld72hogu9ph3e@google.com",
		sequence: 0,
		reminders: {
			useDefault: true
		},
		eventType: "default"
	},
	{
		kind: "calendar#event",
		etag: "\"3187232583216000\"",
		id: "3m5n6mcl1aqrdsg6k5vkr6to5p_20200801T163000Z",
		status: "confirmed",
		htmlLink: "https://www.google.com/calendar/event?eid=M201bjZtY2wxYXFyZHNnNms1dmtyNnRvNXBfMjAyMDA4MDFUMTYzMDAwWiBmdWxsc3RhY2t3ZWJkZXZAY2FyZWVyZm91bmRyeS5jb20",
		created: "2020-07-01T13:54:32.000Z",
		updated: "2020-07-01T15:11:31.608Z",
		summary: "Build Your First App with JavaScript",
		description: "You know basic HTML and CSS, and interested to learn the next thing about web development? Well, you are at the right place. Our workshop will take you to the amazing world of JavaScript. \n\nIn this workshop, you'll:\n- Learn JavaScript, from basics to advanced topics\n- Create your first app",
		location: "Amsterdam, Netherlands",
		creator: {
			email: "fullstackwebdev@careerfoundry.com",
			self: true
		},
		organizer: {
			email: "fullstackwebdev@careerfoundry.com",
			self: true
		},
		start: {
			dateTime: "2020-08-01T18:30:00+02:00",
			timeZone: "Europe/Berlin"
		},
		end: {
			dateTime: "2020-08-01T19:30:00+02:00",
			timeZone: "Europe/Berlin"
		},
		recurringEventId: "3m5n6mcl1aqrdsg6k5vkr6to5p",
		originalStartTime: {
			dateTime: "2020-08-01T18:30:00+02:00",
			timeZone: "Europe/Berlin"
		},
		iCalUID: "3m5n6mcl1aqrdsg6k5vkr6to5p@google.com",
		sequence: 1,
		hangoutLink: "https://meet.google.com/vxc-jcvs-juv",
		conferenceData: {
			entryPoints: [
				{
					entryPointType: "video",
					uri: "https://meet.google.com/vxc-jcvs-juv",
					label: "meet.google.com/vxc-jcvs-juv"
				},
				{
					entryPointType: "more",
					uri: "https://tel.meet/vxc-jcvs-juv?pin=7178471106778",
					pin: "7178471106778"
				},
				{
					regionCode: "DE",
					entryPointType: "phone",
					uri: "tel:+49-40-8081619886",
					label: "+49 40 8081619886",
					pin: "257304091"
				}
			],
			conferenceSolution: {
				key: {
					type: "hangoutsMeet"
				},
				name: "Google Meet",
				iconUri: "https://fonts.gstatic.com/s/i/productlogos/meet_2020q4/v6/web-512dp/logo_meet_2020q4_color_2x_web_512dp.png"
			},
			conferenceId: "vxc-jcvs-juv"
		},
		reminders: {
			useDefault: true
		},
		eventType: "default"
	},
	{
		kind: "calendar#event",
		etag: "\"3187231386852000\"",
		id: "7qqm95l3op6khilck5cprvbq2u_20200802T140000Z",
		status: "confirmed",
		htmlLink: "https://www.google.com/calendar/event?eid=N3FxbTk1bDNvcDZraGlsY2s1Y3BydmJxMnVfMjAyMDA4MDJUMTQwMDAwWiBmdWxsc3RhY2t3ZWJkZXZAY2FyZWVyZm91bmRyeS5jb20",
		created: "2020-07-01T15:00:58.000Z",
		updated: "2020-07-01T15:01:33.426Z",
		summary: "Fun with Angular",
		description: "Developed by Google, AngularJS is a relatively new JavaScript, and it is designed to make front-end development as easy as possible for you. \n\nJoin us to get introduced to this wonderful framework and dive deep into its features. ",
		location: "Dubai - United Arab Emirates",
		creator: {
			email: "fullstackwebdev@careerfoundry.com",
			self: true
		},
		organizer: {
			email: "fullstackwebdev@careerfoundry.com",
			self: true
		},
		start: {
			dateTime: "2020-08-02T16:00:00+02:00",
			timeZone: "Europe/Berlin"
		},
		end: {
			dateTime: "2020-08-02T17:00:00+02:00",
			timeZone: "Europe/Berlin"
		},
		recurringEventId: "7qqm95l3op6khilck5cprvbq2u",
		originalStartTime: {
			dateTime: "2020-08-02T16:00:00+02:00",
			timeZone: "Europe/Berlin"
		},
		iCalUID: "7qqm95l3op6khilck5cprvbq2u@google.com",
		sequence: 1,
		hangoutLink: "https://meet.google.com/bim-zvvi-nio",
		conferenceData: {
			entryPoints: [
				{
					entryPointType: "video",
					uri: "https://meet.google.com/bim-zvvi-nio",
					label: "meet.google.com/bim-zvvi-nio"
				},
				{
					entryPointType: "more",
					uri: "https://tel.meet/bim-zvvi-nio?pin=8340594476418",
					pin: "8340594476418"
				},
				{
					regionCode: "DE",
					entryPointType: "phone",
					uri: "tel:+49-40-8081617267",
					label: "+49 40 8081617267",
					pin: "692195842"
				}
			],
			conferenceSolution: {
				key: {
					type: "hangoutsMeet"
				},
				name: "Google Meet",
				iconUri: "https://fonts.gstatic.com/s/i/productlogos/meet_2020q4/v6/web-512dp/logo_meet_2020q4_color_2x_web_512dp.png"
			},
			conferenceId: "bim-zvvi-nio"
		},
		reminders: {
			useDefault: true
		},
		eventType: "default"
	},
	{
		kind: "calendar#event",
		etag: "\"3187234769062000\"",
		id: "46717o686s7ibj1lp300pabro9_20200802T180000Z",
		status: "confirmed",
		htmlLink: "https://www.google.com/calendar/event?eid=NDY3MTdvNjg2czdpYmoxbHAzMDBwYWJybzlfMjAyMDA4MDJUMTgwMDAwWiBmdWxsc3RhY2t3ZWJkZXZAY2FyZWVyZm91bmRyeS5jb20",
		created: "2020-07-01T15:28:56.000Z",
		updated: "2020-07-01T15:29:44.531Z",
		summary: "React Workshop",
		description: "React is one of the most popular front-end frameworks. There is a huge number of job openings for React developers in most cities. \n\nJoin us in our free React training sessions and give your career a new direction. ",
		location: "Toronto, ON, Canada",
		creator: {
			email: "fullstackwebdev@careerfoundry.com",
			self: true
		},
		organizer: {
			email: "fullstackwebdev@careerfoundry.com",
			self: true
		},
		start: {
			dateTime: "2020-08-02T20:00:00+02:00",
			timeZone: "Europe/Berlin"
		},
		end: {
			dateTime: "2020-08-02T21:00:00+02:00",
			timeZone: "Europe/Berlin"
		},
		recurringEventId: "46717o686s7ibj1lp300pabro9",
		originalStartTime: {
			dateTime: "2020-08-02T20:00:00+02:00",
			timeZone: "Europe/Berlin"
		},
		iCalUID: "46717o686s7ibj1lp300pabro9@google.com",
		sequence: 1,
		hangoutLink: "https://meet.google.com/jnj-edux-duq",
		conferenceData: {
			entryPoints: [
				{
					entryPointType: "video",
					uri: "https://meet.google.com/jnj-edux-duq",
					label: "meet.google.com/jnj-edux-duq"
				},
				{
					entryPointType: "more",
					uri: "https://tel.meet/jnj-edux-duq?pin=3356856978418",
					pin: "3356856978418"
				},
				{
					regionCode: "DE",
					entryPointType: "phone",
					uri: "tel:+49-30-300195194",
					label: "+49 30 300195194",
					pin: "599388176"
				}
			],
			conferenceSolution: {
				key: {
					type: "hangoutsMeet"
				},
				name: "Google Meet",
				iconUri: "https://fonts.gstatic.com/s/i/productlogos/meet_2020q4/v6/web-512dp/logo_meet_2020q4_color_2x_web_512dp.png"
			},
			conferenceId: "jnj-edux-duq"
		},
		reminders: {
			useDefault: true
		},
		eventType: "default"
	},
	{
		kind: "calendar#event",
		etag: "\"3187232047578000\"",
		id: "013qoq4ns44cam7q4hqcf13eab_20200802T230000Z",
		status: "confirmed",
		htmlLink: "https://www.google.com/calendar/event?eid=MDEzcW9xNG5zNDRjYW03cTRocWNmMTNlYWJfMjAyMDA4MDJUMjMwMDAwWiBmdWxsc3RhY2t3ZWJkZXZAY2FyZWVyZm91bmRyeS5jb20",
		created: "2020-07-01T15:05:49.000Z",
		updated: "2020-07-01T15:07:03.789Z",
		summary: "jQuery and More",
		description: "Do you know jQuery is used by around 70 percent of the 10 million most popular websites as of May 2019? \n\nThough many consider it dead after Angular and Express gained popularity, jQuery is still an important part of many websites. \n\nIn our workshop, we teach basic to advanced jQuery where you will also be able to build a simple app using it. If you are familiar with JS, join us to learn probably its most popular library.",
		location: "Santiago, Santiago Metropolitan Region, Chile",
		creator: {
			email: "fullstackwebdev@careerfoundry.com",
			self: true
		},
		organizer: {
			email: "fullstackwebdev@careerfoundry.com",
			self: true
		},
		start: {
			dateTime: "2020-08-03T01:00:00+02:00",
			timeZone: "Europe/Berlin"
		},
		end: {
			dateTime: "2020-08-03T02:00:00+02:00",
			timeZone: "Europe/Berlin"
		},
		recurringEventId: "013qoq4ns44cam7q4hqcf13eab",
		originalStartTime: {
			dateTime: "2020-08-03T01:00:00+02:00",
			timeZone: "Europe/Berlin"
		},
		iCalUID: "013qoq4ns44cam7q4hqcf13eab@google.com",
		sequence: 1,
		hangoutLink: "https://meet.google.com/mqx-jyfg-uoc",
		conferenceData: {
			entryPoints: [
				{
					entryPointType: "video",
					uri: "https://meet.google.com/mqx-jyfg-uoc",
					label: "meet.google.com/mqx-jyfg-uoc"
				},
				{
					entryPointType: "more",
					uri: "https://tel.meet/mqx-jyfg-uoc?pin=9759553023326",
					pin: "9759553023326"
				},
				{
					regionCode: "DE",
					entryPointType: "phone",
					uri: "tel:+49-40-8081618734",
					label: "+49 40 8081618734",
					pin: "678190650"
				}
			],
			conferenceSolution: {
				key: {
					type: "hangoutsMeet"
				},
				name: "Google Meet",
				iconUri: "https://fonts.gstatic.com/s/i/productlogos/meet_2020q4/v6/web-512dp/logo_meet_2020q4_color_2x_web_512dp.png"
			},
			conferenceId: "mqx-jyfg-uoc"
		},
		reminders: {
			useDefault: true
		},
		eventType: "default"
	},
	{
		kind: "calendar#event",
		etag: "\"3187237556010000\"",
		id: "111vmlbl7p8gmc0fbf5u107p8u_20200803T070000Z",
		status: "confirmed",
		htmlLink: "https://www.google.com/calendar/event?eid=MTExdm1sYmw3cDhnbWMwZmJmNXUxMDdwOHVfMjAyMDA4MDNUMDcwMDAwWiBmdWxsc3RhY2t3ZWJkZXZAY2FyZWVyZm91bmRyeS5jb20",
		created: "2020-07-01T15:47:59.000Z",
		updated: "2020-07-01T15:52:58.005Z",
		summary: "React Native Tokyo",
		description: "We meet every Monday and Thursday to talk about React Native and native app development in general. React Native Tokyo is an inclusive community that tries to cater to all levels of learners during meetups. \n\nJoin us if you are curious to hear about what's new in the field of native app development.",
		location: "Tokyo, Japan",
		creator: {
			email: "fullstackwebdev@careerfoundry.com",
			self: true
		},
		organizer: {
			email: "fullstackwebdev@careerfoundry.com",
			self: true
		},
		start: {
			dateTime: "2020-08-03T09:00:00+02:00",
			timeZone: "Europe/Berlin"
		},
		end: {
			dateTime: "2020-08-03T10:00:00+02:00",
			timeZone: "Europe/Berlin"
		},
		recurringEventId: "111vmlbl7p8gmc0fbf5u107p8u",
		originalStartTime: {
			dateTime: "2020-08-03T09:00:00+02:00",
			timeZone: "Europe/Berlin"
		},
		iCalUID: "111vmlbl7p8gmc0fbf5u107p8u@google.com",
		sequence: 1,
		hangoutLink: "https://meet.google.com/ceo-behe-ssp",
		conferenceData: {
			entryPoints: [
				{
					entryPointType: "video",
					uri: "https://meet.google.com/ceo-behe-ssp",
					label: "meet.google.com/ceo-behe-ssp"
				},
				{
					entryPointType: "more",
					uri: "https://tel.meet/ceo-behe-ssp?pin=2641490783465",
					pin: "2641490783465"
				},
				{
					regionCode: "DE",
					entryPointType: "phone",
					uri: "tel:+49-40-8081617770",
					label: "+49 40 8081617770",
					pin: "889553795"
				}
			],
			conferenceSolution: {
				key: {
					type: "hangoutsMeet"
				},
				name: "Google Meet",
				iconUri: "https://fonts.gstatic.com/s/i/productlogos/meet_2020q4/v6/web-512dp/logo_meet_2020q4_color_2x_web_512dp.png"
			},
			conferenceId: "ceo-behe-ssp"
		},
		reminders: {
			useDefault: true
		},
		eventType: "default"
	},
	{
		kind: "calendar#event",
		etag: "\"3181159875584000\"",
		id: "3qtd6uscq4tsi6gc7nmmtpqlct_20200803T120000Z",
		status: "confirmed",
		htmlLink: "https://www.google.com/calendar/event?eid=M3F0ZDZ1c2NxNHRzaTZnYzdubW10cHFsY3RfMjAyMDA4MDNUMTIwMDAwWiBmdWxsc3RhY2t3ZWJkZXZAY2FyZWVyZm91bmRyeS5jb20",
		created: "2020-05-19T19:14:30.000Z",
		updated: "2020-05-27T11:45:37.792Z",
		summary: "React is Fun",
		description: "Love HTML, CSS, and JS? Want to become a cool front-end developer? \n\nReact is one of the most popular front-end frameworks. There is a huge number of job openings for React developers in most cities. \n\nJoin us in our free React training sessions and give your career a new direction. ",
		location: "Berlin, Germany",
		creator: {
			email: "fullstackwebdev@careerfoundry.com",
			self: true
		},
		organizer: {
			email: "fullstackwebdev@careerfoundry.com",
			self: true
		},
		start: {
			dateTime: "2020-08-03T14:00:00+02:00",
			timeZone: "Europe/Berlin"
		},
		end: {
			dateTime: "2020-08-03T15:00:00+02:00",
			timeZone: "Europe/Berlin"
		},
		recurringEventId: "3qtd6uscq4tsi6gc7nmmtpqlct",
		originalStartTime: {
			dateTime: "2020-08-03T14:00:00+02:00",
			timeZone: "Europe/Berlin"
		},
		iCalUID: "3qtd6uscq4tsi6gc7nmmtpqlct@google.com",
		sequence: 0,
		reminders: {
			useDefault: true
		},
		eventType: "default"
	},
	{
		kind: "calendar#event",
		etag: "\"3187234500432000\"",
		id: "65jg7h2f96klim15fie75mj1a1_20200803T140000Z",
		status: "confirmed",
		htmlLink: "https://www.google.com/calendar/event?eid=NjVqZzdoMmY5NmtsaW0xNWZpZTc1bWoxYTFfMjAyMDA4MDNUMTQwMDAwWiBmdWxsc3RhY2t3ZWJkZXZAY2FyZWVyZm91bmRyeS5jb20",
		created: "2020-07-01T15:26:57.000Z",
		updated: "2020-07-01T15:27:30.216Z",
		summary: "AngularJS Workshop",
		description: "Developed by Google, AngularJS is a relatively new JavaScript, and it is designed to make front-end development as easy as possible for you. \n\nJoin us to get introduced to this wonderful framework and dive deep into its features.",
		location: "Cape Town, South Africa",
		creator: {
			email: "fullstackwebdev@careerfoundry.com",
			self: true
		},
		organizer: {
			email: "fullstackwebdev@careerfoundry.com",
			self: true
		},
		start: {
			dateTime: "2020-08-03T16:00:00+02:00",
			timeZone: "Europe/Berlin"
		},
		end: {
			dateTime: "2020-08-03T17:00:00+02:00",
			timeZone: "Europe/Berlin"
		},
		recurringEventId: "65jg7h2f96klim15fie75mj1a1",
		originalStartTime: {
			dateTime: "2020-08-03T16:00:00+02:00",
			timeZone: "Europe/Berlin"
		},
		iCalUID: "65jg7h2f96klim15fie75mj1a1@google.com",
		sequence: 1,
		hangoutLink: "https://meet.google.com/ctp-pwtc-pmq",
		conferenceData: {
			entryPoints: [
				{
					entryPointType: "video",
					uri: "https://meet.google.com/ctp-pwtc-pmq",
					label: "meet.google.com/ctp-pwtc-pmq"
				},
				{
					entryPointType: "more",
					uri: "https://tel.meet/ctp-pwtc-pmq?pin=2824243883315",
					pin: "2824243883315"
				},
				{
					regionCode: "DE",
					entryPointType: "phone",
					uri: "tel:+49-30-300195220",
					label: "+49 30 300195220",
					pin: "987090091"
				}
			],
			conferenceSolution: {
				key: {
					type: "hangoutsMeet"
				},
				name: "Google Meet",
				iconUri: "https://fonts.gstatic.com/s/i/productlogos/meet_2020q4/v6/web-512dp/logo_meet_2020q4_color_2x_web_512dp.png"
			},
			conferenceId: "ctp-pwtc-pmq"
		},
		reminders: {
			useDefault: true
		},
		eventType: "default"
	},
	{
		kind: "calendar#event",
		etag: "\"3187224991890000\"",
		id: "3glt4dve9uip7oh5g5kb2bid2s_20200803T160000Z",
		status: "confirmed",
		htmlLink: "https://www.google.com/calendar/event?eid=M2dsdDRkdmU5dWlwN29oNWc1a2IyYmlkMnNfMjAyMDA4MDNUMTYwMDAwWiBmdWxsc3RhY2t3ZWJkZXZAY2FyZWVyZm91bmRyeS5jb20",
		created: "2020-07-01T14:07:59.000Z",
		updated: "2020-07-01T14:08:15.945Z",
		summary: "Fun with Node.js",
		description: "Do you know that Node.js is basically a server having the capability of executing JavaScript? If you are familiar with JS, Node.js will be an easy ride. \n\nJoin us if you want to learn how to build the server-side of an app using Node.js.",
		location: "Nairobi, Kenya",
		creator: {
			email: "fullstackwebdev@careerfoundry.com",
			self: true
		},
		organizer: {
			email: "fullstackwebdev@careerfoundry.com",
			self: true
		},
		start: {
			dateTime: "2020-08-03T18:00:00+02:00",
			timeZone: "Europe/Berlin"
		},
		end: {
			dateTime: "2020-08-03T19:00:00+02:00",
			timeZone: "Europe/Berlin"
		},
		recurringEventId: "3glt4dve9uip7oh5g5kb2bid2s",
		originalStartTime: {
			dateTime: "2020-08-03T18:00:00+02:00",
			timeZone: "Europe/Berlin"
		},
		iCalUID: "3glt4dve9uip7oh5g5kb2bid2s@google.com",
		sequence: 1,
		hangoutLink: "https://meet.google.com/wkx-akyy-omd",
		conferenceData: {
			entryPoints: [
				{
					entryPointType: "video",
					uri: "https://meet.google.com/wkx-akyy-omd",
					label: "meet.google.com/wkx-akyy-omd"
				},
				{
					entryPointType: "more",
					uri: "https://tel.meet/wkx-akyy-omd?pin=9536747460380",
					pin: "9536747460380"
				},
				{
					regionCode: "DE",
					entryPointType: "phone",
					uri: "tel:+49-40-8081616512",
					label: "+49 40 8081616512",
					pin: "576339034"
				}
			],
			conferenceSolution: {
				key: {
					type: "hangoutsMeet"
				},
				name: "Google Meet",
				iconUri: "https://fonts.gstatic.com/s/i/productlogos/meet_2020q4/v6/web-512dp/logo_meet_2020q4_color_2x_web_512dp.png"
			},
			conferenceId: "wkx-akyy-omd"
		},
		reminders: {
			useDefault: true
		},
		eventType: "default"
	}
];

export default mockData